// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"63697c31","539":"90d4a0b8","630":"2a78cb6d","637":"3b29cdf8","643":"1f110dc4"}[chunkId] + ".chunk.css";
};